import { Formik } from 'formik';
import * as Yup from 'yup';
import React, { useEffect, useState } from 'react';
import TextArea from 'components/form/TextArea';
import Button from 'components/form/Button';
import { useDispatch, useSelector } from 'react-redux';
import { decrypt, encrypt, objectToFormData } from 'utils/helpers';
import { showSuccess, handleEditRequestEvent } from 'store/slices';
import usePermission from 'hooks/usePermission';

const EventAcceptanceLetterheadRequestForm = ({
  eventId,
  fetchEventDetails,
  eventTab = false,
  handleNext,
  isViewMode,
}) => {
  const dispatch = useDispatch();
  const { requestEventData } = useSelector((state) => ({
    requestEventData: state.global.requestEventData,
  }));

  const { createAccess, updateAccess } = usePermission("Requests");

  const [btnLoading, setBtnLoading] = useState(false);
  const [showPreview, setShowPreview] = useState('');
  const [currentPreview, setCurrentPreview] = useState('');

  const isEdit = requestEventData?.acceptance_head;
  const previewLetterhead = requestEventData?.acceptance_head?.html_letter;

  const initialValues = { htmlLetter: isEdit ? previewLetterhead : '' };
  const validationSchema = Yup.object().shape({
    htmlLetter: Yup.string().required('HTML code is required.'),
  });

  const handleSave = async (values) => {
    setBtnLoading(true);

    const payloadData = {
      html_letter: encrypt(values?.htmlLetter),
      type: 6,
      request_id: eventId,
      acceptance_data: true,
    };
    const payload = objectToFormData(payloadData);
    const response = await dispatch(handleEditRequestEvent(payload));
    if (response?.status === 200) {
      fetchEventDetails();
      dispatch(showSuccess(`Acceptance format uploaded successfully.`));
    }
    setBtnLoading(false);
  };

  useEffect(() => {
    if (showPreview) {
      setCurrentPreview(showPreview);
    } else if (previewLetterhead) {
      setCurrentPreview(previewLetterhead);
    } else {
      setCurrentPreview('');
    }
  }, [showPreview, previewLetterhead]);

  return (
    <div className="acceptance-letterhead-container row">
      <Formik
        initialValues={initialValues}
        onSubmit={handleSave}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(props) => {
          const { values, errors, handleChange, handleSubmit, resetForm } =
            props;
          return (
            <form className="col-md-6">
              <div className="cmb-15">
                <TextArea
                  label={'HTML Content'}
                  isRequired
                  id="htmlLetter"
                  value={values?.htmlLetter}
                  onChange={handleChange}
                  error={errors?.htmlLetter}
                  rows={10}
                  placeholder="Write your HTML code here..."
                  disabled={isViewMode}
                />
              </div>
              {/* {eventTab && !isViewMode ? ( */}

              {!isViewMode && (
                <div className="d-flex flex-wrap gap-2">
                  <div className="flex-grow-1 flex-sm-grow-0">
                    <Button
                      text={'Preview'}
                      btnStyle={'primary-dark'}
                      className={'w-100 w-sm-auto cps-20 cpe-20 h-37'}
                      disabled={!values?.htmlLetter}
                      onClick={() => {
                        setShowPreview(values?.htmlLetter);
                      }}
                    />
                  </div>

                  {(updateAccess === '1' || createAccess === '1') && (
                    <div className="flex-grow-1 flex-sm-grow-0">
                      <Button
                        text={'Save'}
                        btnStyle={'primary-dark'}
                        className={'w-100 w-sm-auto cps-20 cpe-20 h-37'}
                        onClick={handleSubmit}
                        disabled={!showPreview || btnLoading}
                        btnLoading={btnLoading}
                      />
                    </div>
                  )}
                  <div className="flex-grow-1 flex-sm-grow-0">
                    <Button
                      text={'Reset'}
                      btnStyle="light-outline"
                      className={'w-100 w-sm-auto cps-20 cpe-20 h-37'}
                      onClick={() => {
                        resetForm();
                        setShowPreview('');
                      }}
                      disabled={btnLoading}
                    />
                  </div>

                  <div className="flex-grow-1 flex-sm-grow-0">
                    <Button
                      text={'Procced Next'}
                      btnStyle="light-outline"
                      className={'w-100 w-sm-auto cps-20 cpe-20 h-37'}
                      onClick={() => {
                        resetForm();
                        handleNext('acceptance_letterhead');
                      }}
                      disabled={btnLoading}
                    />
                  </div>
                </div>
              )}
            </form>
          );
        }}
      </Formik>
      <div className={`cpt-20 col-md-6 cmb-15`}>
        {currentPreview ? (
          <div
            style={{
              maxHeight: '700px',
              overflowY: 'auto',
              border: '1px solid #ccc',
              padding: '10px',
              backgroundColor: '#f8f9fa',
            }}
            dangerouslySetInnerHTML={{
              __html: currentPreview,
            }}
          />
        ) : (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              maxHeight: '500px',
              height: '225px',
              overflowY: 'auto',
              border: '1px solid #ccc',
              backgroundColor: '#f8f9fa',
            }}
          >
            No preview available
          </div>
        )}
      </div>
    </div>
  );
};

export default EventAcceptanceLetterheadRequestForm;
